// extracted by mini-css-extract-plugin
export default {"cta":"style_cta__7qGK3","cta__button":"style_cta__button__0eiR8"};